import { AxiosAuth } from "../core/axios";

export async function getData(url: string) {
  try {
    const response = await AxiosAuth.get(url);
    return response;
  } catch (error: any) {
    const reason = JSON.parse(error.message);
    return reason;
  }
}

export async function postData(url: string, data: any) {
  try {
    const response = await AxiosAuth.post(url, data);
    return response;
  } catch (error: any) {
    const reason = JSON.parse(error.message);
    return reason;
  }
}

export async function putData(url: string, data: any) {
  try {
    const response = await AxiosAuth.put(url, data);
    return response;
  } catch (error: any) {
    const reason = JSON.parse(error.message);
    return reason;
  }
}

export async function deleteData(url: string) {
  try {
    // const response = await AxiosAuth.delete(url);
    const response = await AxiosAuth.post(url);
    return response;
  } catch (error: any) {
    const reason = JSON.parse(error.message);
    return reason;
  }
}

export const base64ToFile = async (base64Data: string, title: string) => {
  if (base64Data) {
    const response = await fetch(`data:application/pdf;base64,${base64Data}`);
    const buf = await response.arrayBuffer();
    const pdfFile = new File([buf], title, { type: "application/pdf" });

    return [{ blobFile: pdfFile, name: title }];
  }
};

export const convertDate = (date: string) => {
  if (date) {
    const value = new Date(date);
    const day = value.getDate();
    const month = value.toLocaleString("default", { month: "short" });
    const year = value.getFullYear();

    const result = `${month} ${day}, ${year}`;

    return result;
  } else return "";
};
